(function(global) {
    'use strict';

    class CountdownTimer {
        constructor(container, endDate, prefix = '') {
            this.container = typeof container === 'string'
                ? document.getElementById(container)
                : container;

            if (!this.container || !endDate) {
                if (this.container) this.container.style.display = 'none';
                return;
            }

            this.endDate = new Date(endDate).getTime();
            if (isNaN(this.endDate)) {
                this.container.style.display = 'none';
                return;
            }

            this.prefix = prefix;
            this.render();
            this.interval = setInterval(() => this.render(), 1000);
        }

        render() {
            const distance = this.endDate - Date.now();

            if (distance < 0) {
                window.location.reload();
                return;
            }

            const time = {
                days: Math.floor(distance / 86400000),
                hours: Math.floor((distance % 86400000) / 3600000),
                minutes: Math.floor((distance % 3600000) / 60000),
                seconds: Math.floor((distance % 60000) / 1000)
            };

            const segments = Object.entries(time)
                .map(([unit, value]) => `
                    <div class="countdown-segment">
                        <div class="countdown-value">${String(value).padStart(2, '0')}</div>
                        <div class="countdown-label">${value === 1 ? unit.slice(0, -1) : unit}</div>
                    </div>
                `).join('<div class="countdown-separator">:</div>');

            this.container.innerHTML = `
                <div class="countdown-wrapper">
                    ${this.prefix ? `<div class="countdown-prefix">${this.prefix}</div>` : ''}
                    <div class="countdown-display">${segments}</div>
                </div>
            `;
        }

        destroy() {
            if (this.interval) clearInterval(this.interval);
        }
    }

    // Universal Module Definition (UMD) pattern for maximum compatibility
    if (typeof module === 'object' && typeof module.exports === 'object') {
        // CommonJS
        module.exports = CountdownTimer;
    } else if (typeof define === 'function' && define.amd) {
        // AMD
        define([], function() { return CountdownTimer; });
    } else {
        // Browser global
        global.CountdownTimer = CountdownTimer;
    }

})(typeof window !== 'undefined' ? window : this);